import React from 'react';
import Back from '../../components/Back';
import {useQuery} from '@apollo/client';
import {QUERY_CONTEST_DETAIL} from './graphql';
import Query from '../../components/Query';
import moment from 'moment';
import Avatar from '../../components/Avatar';

export const ContestRating = ({match}) => {
  const query = useQuery(QUERY_CONTEST_DETAIL, {variables: {id: match.params.id}});
  const obj = query.data ? query.data.contestDetail : null;

  return (
    <div className="container py-4">
      <div className="row align-items-center g-3"> 
        <div className="col-auto">
          <Back />
        </div>
        <div className="col-auto font-4">{obj?.name}</div>
      </div>
      <div className="flex">
        {Query(query) || (
          moment(obj.endTime).isAfter(moment()) ? (
            <div className="py-4 text-center">Еще не закончился</div>
          ) : (
            <div className="mt-4 col-md-10 col-lg-8 col-xl-7 mx-auto">
              <div className="row px-3 text-muted font-2">
                <div className="col">Участник</div>
                <div className="col-2 text-end">Ответы</div>
                <div className="col-2 text-end">Время</div>
              </div>
              <div className="list-group mt-2">
                {obj.contestClients.map(cc => (
                  <div key={cc.id} className="list-group-item">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="row align-items-center gx-2">
                          <div className="col-auto">
                            <Avatar user={cc.client.user} size={30} />
                          </div>
                          <div className="col font-2">
                            <div>{cc.client.user.fullname}</div>
                            <div className="font-1 text-muted">ID: {('000000' + cc.client.id).slice(-6)}</div>
                          </div>
                        </div>
                      </div>
                      {cc.isWinner && (
                        <div className="col">
                          <div style={{transform: 'rotate(-5deg)', width: 60}} className="border text-center border-info text-info">ПРИЗ</div>
                        </div>
                      )}
                      <div className="col-2 text-end">{cc.answersCount}</div>
                      <div className="col-2 text-end">{moment.utc(cc.duration * 1000).format('mm:ss')}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ContestRating;
